/** Payload module_data : l’API n’accepte qu’un objet JSON, jamais un tableau racine. */

export function wrapModuleDataPayload(value: unknown): Record<string, unknown> {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return { value };
}

export function unwrapModuleDataPayload(payload: Record<string, unknown>): unknown {
  if ('value' in payload && Object.keys(payload).length === 1) {
    return payload.value;
  }
  return payload;
}

export function registerPayload<T>(items: T[]): { items: T[] } {
  return { items };
}

/** Accepte { items }, un tableau brut (legacy local) ou { value } (wrap remote). */
export function normalizeRegisterList<T>(data: unknown, fallback: T[] = []): T[] {
  if (Array.isArray(data)) return data as T[];
  if (!data || typeof data !== 'object') return fallback;
  const rec = data as { items?: unknown; value?: unknown };
  if (Array.isArray(rec.items)) return rec.items as T[];
  if (Array.isArray(rec.value)) return rec.value as T[];
  return fallback;
}
